import axios from "axios";
import { apiBaseUrl } from "../branding";

const apiService = axios.create({
  baseURL: apiBaseUrl,
});

class HttpService {
  async getSertifikasiByCode(code: string): Promise<any> {
    const response = await apiService.get(
      `/sertifikasi/find-by-code?code=${code}`
    );
    return response.data;
  }
}

export default HttpService;
